import React from 'react'

export default function LeadGen() {
    return (
        <>

            <div className="tab-inner-section">
                <div className="trans-header">
                    <div className="lead-gen-wrapper">
                        <div className="tab-inner-wrapper">
                            <div className="tab-inner-heading d-flex justify-content-between align-items-center">
                                <div className="left-wrap">
                                    <div className="dropdown table-dropdown ques-options">
                                        <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            <span className='me-2'>labels/ Placeholder</span>
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="languages">
                                            <span className="dropdown-item-text">INPUT</span>
                                            <a className="dropdown-item" href="#">
                                                Label / Placeholder
                                            </a>
                                            <span className="dropdown-item-text">DROP DOWN</span>
                                            <a className="dropdown-item" href="#">
                                                Countries
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                States
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Industries
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Designations
                                            </a>
                                            <span className="dropdown-item-text">MESSAGES</span>
                                            <a className="dropdown-item" href="#">
                                                Consent
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Error messages
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="trans-header">
                    <div className="d-flex lead-gen-wrapper">

                        <div className="flex-grow-1 lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="tab-inner-heading">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="left-wrap d-flex">
                                                    <div className="drop-wrap ques-options">
                                                        <h5>ENG</h5>
                                                        <p>Default</p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="tab-inner-heading">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="left-wrap d-flex">
                                                    <div className="drop-wrap">
                                                        <div className="dropdown table-dropdown ques-options">
                                                            <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false">
                                                                <span className='me-2'>SPA</span>
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="languages">
                                                                <a className="dropdown-item" href="#">
                                                                    English
                                                                </a>
                                                                <a className="dropdown-item" href="#">
                                                                    German
                                                                </a>
                                                                <a className="dropdown-item" href="#">
                                                                    Spanish
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <p>Spanish</p>
                                                    </div>
                                                </div>
                                                <div className="right-action-btn">
                                                    <button type="button" className="btn btn-bordered">Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="trans-wrap">

                    <div className="lead-gen-wrapper">
                        <div className="lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center checked">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check1" defaultChecked />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>Heading</p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">
                                                    <textarea className="choiceItext single-line" cols={1} defaultValue={"Überschrift"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="lead-gen-wrapper">
                        <div className="lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check1" />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>Description</p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">
                                                    <textarea className="choiceItext single-line" cols={1} defaultValue={"Bezeichnung"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lead-gen-wrapper">
                        <div className="lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check1" />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>First name</p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">
                                                    <textarea className="choiceItext single-line" cols={1} defaultValue={"Vorname"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lead-gen-wrapper">
                        <div className="lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check5" />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>Last name</p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">
                                                    <textarea className="choiceItext single-line" cols={1} defaultValue={"Achternaam"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            {/*Error Message Transalation*/}

            {/* <div className="tab-inner-section">
                <div className="trans-header">
                    <div className="lead-gen-wrapper">
                        <div className="tab-inner-wrapper">
                            <div className="tab-inner-heading d-flex justify-content-between align-items-center">
                                <div className="left-wrap">
                                    <div className="dropdown table-dropdown ques-options">
                                        <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            <span className='me-2'>Error messages</span>
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="languages">
                                            <span className="dropdown-item-text">INPUT</span>
                                            <a className="dropdown-item" href="#">
                                                Label / Placeholder
                                            </a>
                                            <span className="dropdown-item-text">DROP DOWN</span>
                                            <a className="dropdown-item" href="#">
                                                Countries
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                States
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Industries
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Designations
                                            </a>
                                            <span className="dropdown-item-text">MESSAGES</span>
                                            <a className="dropdown-item" href="#">
                                                Consent
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Error messages
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="trans-header">
                    <div className="d-flex lead-gen-wrapper">
                        <div className="lead-gen-left">
                            <div className="tab-inner-wrapper">
                                <div className="tab-inner-heading d-flex justify-content-between align-items-center">
                                    <div className="left-wrap">
                                        <div className="ques-options">
                                            <h5>Error</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex-grow-1 lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="tab-inner-heading">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="left-wrap d-flex">
                                                    <div className="drop-wrap ques-options">
                                                        <h5>ENG</h5>
                                                        <p>Default</p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="tab-inner-heading">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="left-wrap d-flex">
                                                    <div className="drop-wrap">
                                                        <div className="dropdown table-dropdown ques-options">
                                                            <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false">
                                                                <span className='me-2'>SPA</span>
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="languages">
                                                                <a className="dropdown-item" href="#">
                                                                    English
                                                                </a>
                                                                <a className="dropdown-item" href="#">
                                                                    German
                                                                </a>
                                                                <a className="dropdown-item" href="#">
                                                                    Spanish
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <p>Spanish</p>
                                                    </div>
                                                </div>
                                                <div className="right-action-btn">
                                                    <button type="button" className="btn btn-bordered">Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="trans-wrap">
                    <div className="d-flex lead-gen-wrapper">
                        <div className="lead-gen-left">
                            <div className="tab-inner-wrapper">
                                <div className="questions-wrapper">
                                    <div className="translation-list">
                                        <div className="translate"><p>Email input</p></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex-grow-1 lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check1" />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>Please enter a valid email address.</p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">

                                                    <textarea className="choiceItext single-line" cols={1} defaultValue={"Te rog introdu o adresa de email valida."} />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex lead-gen-wrapper">
                        <div className="lead-gen-left">
                            <div className="tab-inner-wrapper">
                                <div className="questions-wrapper">
                                    <div className="translation-list">
                                        <div className="translate"><p>First name</p></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex-grow-1 lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center checked">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check1" defaultChecked />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>Please enter your first name</p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">

                                                    <textarea className="choiceItext single-line" cols={1} defaultValue={"Vă rugăm să introduceți prenumele dvs"} />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex lead-gen-wrapper">
                        <div className="lead-gen-left">
                            <div className="tab-inner-wrapper">
                                <div className="questions-wrapper">
                                    <div className="translation-list">
                                        <div className="translate"><p>Last name</p></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex-grow-1 lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check1" />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>Please enter your last name</p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">
                                                    <textarea className="choiceItext single-line" cols={1} defaultValue={"Vă rugăm să introduceți numele dvs. de familie"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex lead-gen-wrapper">
                        <div className="lead-gen-left">
                            <div className="tab-inner-wrapper">
                                <div className="questions-wrapper">
                                    <div className="translation-list">
                                        <div className="translate"><p>Organization name</p></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex-grow-1 lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check1" />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>Please enter organization name</p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">
                                                    <textarea className="choiceItext single-line" cols={1} defaultValue={"Vă rugăm să introduceți numele organizației"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div> */}


            {/*Country State Transalation*/}

            {/* <div className="tab-inner-section">
                <div className="trans-header">
                    <div className="lead-gen-wrapper">
                        <div className="tab-inner-wrapper">
                            <div className="tab-inner-heading d-flex align-items-center">
                                <div className="left-wrap">
                                    <div className="dropdown table-dropdown ques-options">
                                        <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            <span className='me-2'>States</span>
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="languages">
                                            <span className="dropdown-item-text">INPUT</span>
                                            <a className="dropdown-item" href="#">
                                                Label / Placeholder
                                            </a>
                                            <span className="dropdown-item-text">DROP DOWN</span>
                                            <a className="dropdown-item" href="#">
                                                Countries
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                States
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Industries
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Designations
                                            </a>
                                            <span className="dropdown-item-text">MESSAGES</span>
                                            <a className="dropdown-item" href="#">
                                                Consent
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Error messages
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="left-wrap">
                                    <div className="dropdown table-dropdown ques-options">
                                        <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            <span className='me-2'>Country</span>
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="languages">
                                            <span className="dropdown-item-text">INPUT</span>
                                            <a className="dropdown-item" href="#">
                                                Label / Placeholder
                                            </a>
                                            <span className="dropdown-item-text">DROP DOWN</span>
                                            <a className="dropdown-item" href="#">
                                                Countries
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                States
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Industries
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Designations
                                            </a>
                                            <span className="dropdown-item-text">MESSAGES</span>
                                            <a className="dropdown-item" href="#">
                                                Consent
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Error messages
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="trans-header">
                    <div className="d-flex lead-gen-wrapper">
                        <div className="flex-grow-1 lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="tab-inner-heading">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="left-wrap d-flex">
                                                    <div className="drop-wrap ques-options">
                                                        <h5>ENG</h5>
                                                        <p>Default</p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="tab-inner-heading">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="left-wrap d-flex">
                                                    <div className="drop-wrap">
                                                        <div className="dropdown table-dropdown ques-options">
                                                            <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false">
                                                                <span className='me-2'>SPA</span>
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="languages">
                                                                <a className="dropdown-item" href="#">
                                                                    English
                                                                </a>
                                                                <a className="dropdown-item" href="#">
                                                                    German
                                                                </a>
                                                                <a className="dropdown-item" href="#">
                                                                    Spanish
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <p>Spanish</p>
                                                    </div>
                                                </div>
                                                <div className="right-action-btn">
                                                    <button type="button" className="btn btn-bordered">Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="trans-wrap">
                    <div className="lead-gen-wrapper">
                        <div className="lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center checked">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check1" defaultChecked />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>Andhra Pradesh</p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">
                                                    <textarea className="choiceItext single-line" cols={1} defaultValue={"Andhra Pradesh"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="lead-gen-wrapper">
                        <div className="lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check1" />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>Arunachal Pradesh</p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">
                                                    <textarea className="choiceItext single-line" cols={1} defaultValue={"Arunachal Pradesh"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lead-gen-wrapper">
                        <div className="lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check1" />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>Assam</p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">
                                                    <textarea className="choiceItext single-line" cols={1} defaultValue={"Assam"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lead-gen-wrapper">
                        <div className="lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check5" />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>Bihar</p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">
                                                    <textarea className="choiceItext single-line" cols={1} defaultValue={"Bihar"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div> */}


            {/*Consent Transalation*/}

            {/* <div className="tab-inner-section">
                <div className="trans-header">
                    <div className="lead-gen-wrapper">
                        <div className="tab-inner-wrapper">
                            <div className="tab-inner-heading d-flex align-items-center">
                                <div className="left-wrap">
                                    <div className="dropdown table-dropdown ques-options">
                                        <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            <span className='me-2'>Consent</span>
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="languages">
                                            <span className="dropdown-item-text">INPUT</span>
                                            <a className="dropdown-item" href="#">
                                                Label / Placeholder
                                            </a>
                                            <span className="dropdown-item-text">DROP DOWN</span>
                                            <a className="dropdown-item" href="#">
                                                Countries
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                States
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Industries
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Designations
                                            </a>
                                            <span className="dropdown-item-text">MESSAGES</span>
                                            <a className="dropdown-item" href="#">
                                                Consent
                                            </a>
                                            <a className="dropdown-item" href="#">
                                                Error messages
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="trans-header">
                    <div className="lead-gen-wrapper">
                        <div className="lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="tab-inner-heading">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="left-wrap d-flex">
                                                    <div className="drop-wrap ques-options">
                                                        <h5>ENG</h5>
                                                        <p>Default</p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="tab-inner-heading">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="left-wrap d-flex">
                                                    <div className="drop-wrap">
                                                        <div className="dropdown table-dropdown ques-options">
                                                            <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false">
                                                                <span className='me-2'>SPA</span>
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="languages">
                                                                <a className="dropdown-item" href="#">
                                                                    English
                                                                </a>
                                                                <a className="dropdown-item" href="#">
                                                                    German
                                                                </a>
                                                                <a className="dropdown-item" href="#">
                                                                    Spanish
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <p>Spanish</p>
                                                    </div>
                                                </div>
                                                <div className="right-action-btn">
                                                    <button type="button" className="btn btn-bordered">Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="trans-wrap">
                    <div className="lead-gen-wrapper">
                        <div className="lead-gen-main">
                            <div className="row gx-0">
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate d-flex align-items-center checked">
                                                    <div className="Sortingcheck">
                                                        <input type="checkbox" className="form-check-input" id="language-check1" defaultChecked />
                                                    </div>
                                                    <div className='chiceFields choiceInput flex-grow-1'>
                                                        <div className="translate"><p>Yes, I consent to receive the occasional emails with updates on services from Survey Tool. I can always unsubscribe. </p></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tab-inner-wrapper right-tab">
                                        <div className="questions-wrapper">
                                            <div className="translation-list">
                                                <div className="translate">
                                                    <textarea className="choiceItext" cols={1} defaultValue={"Sí, day mi consentimiento para recibir correos electrónicos ocasionales con actualizaciones sobre los servicios de Survey Tool. Siempre puedo darme de baja."} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    

                </div>
            </div> */}
        </>

    )
}
